// extracted by mini-css-extract-plugin
module.exports = {"mainSiteHeader":"MainSiteHeader_mainSiteHeader__DArQ9"};